module.exports = __webpack_public_path__ + "static/img/iconfont.7e0e0ec7.svg";